import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { FileInputMateDrive, TabPanel } from '../../../FlowConfigurationInputs';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { CheckIfFlowUpdated } from '../../../../helpers/helper';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Emirhan Bilal Yeşil
 */
function Encode({ action, showAlert, variables, setOpenVariable, automId }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const label = 'CONTENT.CONFIGURATION-FORM.BASE64.';

    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() === 'js' && ext.toLocaleLowerCase() !== 'html') {
                    showAlert(t(label + 'NOT-SUPPORT-JS-OR-HTML'));
                    return false;
                }
                return true;
            },
            // fileType: '.xlsm, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    }

    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };

        } else {
            if (action.fields.fieldType?.value === "CS") {
                setValue(2);
            }
            else if (action.fields.fileType?.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }
    }, [action, variables])

    function handleChangeTabs(newValue) {
        // if the tab is File Path
        if (newValue === 1) {
            if (action.fields.set?.variableType === "string") {
                delete action.fields.set
            }
            // if (action.fields.set?.variableType === "string") {
            //     action.fields.setBackupString = action.fields.set
            // }
            // if (action.fields.setBackupObject) {
            //     action.fields.set = action.fields.setBackupObject
            // } else {
            //     delete action.fields.set
            // }
            //action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            // if (!action.fields.filePath.backup?.value) {
            //     action.fields.filePath.backup = { value: action.fields.filePath.value }
            // }

            if (action.fields.fieldType?.value === "FILE") {
                action.fields.filePath.backup = { value: action.fields.filePath.value };
            }
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
            action.fields.fieldType = { value: "FP" }
            delete action.fields.fieldData
            action.fields.filePath.isRequired = true;
            // if the tab is Select File
        } else if (newValue === 0) {
            if (action.fields.set?.variableType === "string") {
                delete action.fields.set
            }
            // if (action.fields.set?.variableType === "string") {
            //     action.fields.setBackupString = action.fields.set
            // }
            // if (action.fields.setBackupObject) {
            //     action.fields.set = action.fields.setBackupObject
            // } else {
            //     delete action.fields.set
            // }

            // action.fields.filePath.type = 'FILE';//
            action.fields.fileType.value = 'FILE';
            // if (!action.fields.filePath.backupText) {
            //     action.fields.filePath.backupText = { value: action.fields.filePath.value }
            // }

            if (action.fields.fieldType?.value === "FP") {
                action.fields.filePath.backupText = { value: action.fields.filePath.value }
            }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
            action.fields.fieldType = { value: "FILE" }
            delete action.fields.fieldData
            action.fields.filePath.isRequired = true;
            // if the tab is Custom String
        } else {
            // if (action.fields.set?.variableType === "object") {
            //     action.fields.setBackupObject = action.fields.set
            // }
            // if (action.fields.setBackupString) {
            //     action.fields.set = action.fields.setBackupString
            // } else {
            //     delete action.fields.set
            // }
            delete action.fields.set
            if (action.fields.fieldType?.value === "FILE") {
                action.fields.filePath.backup = { value: action.fields.filePath.value }
            }
            if (action.fields.fieldType?.value === "FP") {
                action.fields.filePath.backupText = { value: action.fields.filePath.value }
            }
            action.fields.fieldType = { value: "CS" }
            action.fields.fileType.value = "";
            if (!action.fields.fieldData?.value) {
                action.fields.fieldData = { value: "", isRequired: true }
            }
            action.fields.filePath.isRequired = false;
        }
        const field = initialActionsData[action.id]?.fields.fieldType;
        const oldValue = !field ? undefined : field.value;
        let v = newValue === 1 ? "TEXT" : newValue === 2 ? "CS" : "FILE";
        CheckIfFlowUpdated("fieldType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
        setValue(newValue);
    }

    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ENCODE.DATA')} is_required />
                <div className="condition-tabs" style={{ marginBottom: 5 }}>
                    <button
                        className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'ENCODE.SELECT-FILE')}
                    </button>
                    <button
                        className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'ENCODE.FILE-PATH')}
                    </button>
                    <button
                        className={`f-s-11 ${value === 2 ? 'condition-active' : ''}`}
                        onClick={() => handleChangeTabs(2)}>
                        {t(label + 'ENCODE.CUSTOM-STRING')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                    <FileInputMateDrive action={action} inputName="filePath" options={options.fileInput} isRequired
                        isSize={true} clear={true} hideRequired autom_id={automId} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired setOpenVariable={setOpenVariable}
                        variables={variables} autom_id={automId} hideRequired />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <TextInput action={action} inputName="fieldData" isRequired setOpenVariable={setOpenVariable}
                        variables={variables} autom_id={automId} hideRequired />
                </TabPanel>
            </div>
            {(value === 1 || value === 0) ? (
                <div key="objectPicker" className="conf-field-container">
                    <FieldLabel name={t(label + 'ENCODE.ASSIGN-VALUE')} is_required />
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable} filter="object" isRequired hideRequired />
                    <small
                        className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
                    <div>
                        <small className="conf-field-desc"><em>{t("CONTENT.GENERAL.EXAMPLE-RESPONSE")}</em></small>
                    </div>
                    <div>
                        <small className="conf-field-desc"><em>{"{\"Name\":\"test\",\"Extension\":\"txt\",\"Size\":11,\"Base64\":\"dGVzdA==\"}"}</em></small>
                    </div>
                </div>
            ) : value === 2 ? (
                <div key="stringPicker" className="conf-field-container">
                    <FieldLabel name={t(label + 'ENCODE.ASSIGN-VALUE')} is_required />
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable} filter="string" isRequired hideRequired />
                    <small
                        className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
                </div>
            ) : null
            }

        </>
    );
}

export default Encode;